import { Box, Collapse } from "@mui/material";
import { styled } from "@mui/material/styles";
import InfoBannerHeader from "./InfoBannerHeader";
import GettingStartedWithLocations from "./GettingStartedWithLocations";
import {MouseEventHandler} from "react";

interface InfoBannerProps {
  /** Whether the info banner is expanded or not */
  isExpanded: boolean;
  /** Callback to toggle the expanded state of the info banner */
  onExpandToggle: MouseEventHandler<HTMLButtonElement> | undefined;
}

const InfoBannerRoot = styled(Box)({
  backgroundColor: "#fff",
  border: "1px solid #e0e6ec",
  borderRadius: "8px",
  marginBottom: "24px",
  overflow: "hidden",
  boxShadow: "0 1px 6px rgba(0,0,0,0.05)",
});

const InfoBannerBody = styled(Box)({
  padding: "20px",
});

/**
 * Controlled collapsible "Getting Started with Locations" banner.
 *
 * Displays a header with title and collapsible toggle, and an expandable body
 * containing workflow steps, tips, and guidance on the location approval process.
 *
 * @example
 * const [isExpanded, setIsExpanded] = useState(true);
 * return <InfoBanner isExpanded={isExpanded} onExpandToggle={() => setIsExpanded(!isExpanded)} />
 */
const InfoBanner = ({isExpanded, onExpandToggle}: InfoBannerProps) => {
  return (
    <InfoBannerRoot>
      <InfoBannerHeader isExpanded={isExpanded} onClick={onExpandToggle} />
      <Collapse in={isExpanded}>
        <InfoBannerBody
          id="info-banner-body"
          role="region"
          aria-label="Getting started with Locations"
        >
          <GettingStartedWithLocations />
        </InfoBannerBody>
      </Collapse>
    </InfoBannerRoot>
  );
};

export default InfoBanner;
